import { useCallback, useEffect } from "react";

import {
  IncomingCusipPosition,
  IncomingTickerPosition,
} from "@fartherfinance/frontend/api/Investment/types";
import useGetTransitionalProposalPlanStats from "@fartherfinance/frontend/api/TransitionProposals/hooks/useGetTransitionalProposalPlanStats";
import { RequestConfig } from "@fartherfinance/frontend/api/Types";

export default (auth: RequestConfig | null) => {
  const useGetData = useCallback(
    (positions: (IncomingCusipPosition | IncomingTickerPosition)[] = []) => {
      const {
        isLoadingPortfolioStats,
        hasPortfolioStatsError,
        portfolioStats,
        invalidPositions,
        fetchPortfolioStats,
        retryWithFilteredPositions,
        reset,
      } = useGetTransitionalProposalPlanStats(auth);

      useEffect(() => {
        const fetchData = async (): Promise<void> => {
          reset();
          if (positions.length === 0) {
            return;
          }

          await fetchPortfolioStats({
            type: "positions",
            positions,
          });
        };
        fetchData();
      }, [fetchPortfolioStats, reset, positions]);

      useEffect(() => {
        const retryWithFiltered = async (): Promise<void> => {
          if (positions.length === 0 || invalidPositions.length === 0) {
            return;
          }

          await retryWithFilteredPositions({
            type: "positions",
            positions,
          });
        };
        retryWithFiltered();
      }, [retryWithFilteredPositions, invalidPositions, positions]);

      return {
        isLoadingPortfolioStats,
        hasPortfolioStatsError,
        portfolioStats,
        invalidPositions,
      };
    },
    [auth]
  );
  return useGetData;
};
